import { render, staticRenderFns } from "./detailsOfTrainingBull.vue?vue&type=template&id=274b9b94&scoped=true&"
import script from "./detailsOfTrainingBull.vue?vue&type=script&lang=js&"
export * from "./detailsOfTrainingBull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274b9b94",
  null
  
)

export default component.exports